import {AxiosError} from 'axios';
import {POST_ADMIN_DETAILS_URL} from 'web-library/constants/apiUrls';
import {PaginatedData} from 'web-library/models/List';
import {
  AdminDetailsResponseContentObject,
  DataTableRequestSearchBody,
} from 'web-library/models/UserGroupAccessConfiguration/UserGroupAccessConfiguration';
import axiosClient from '../axiosClient';
import {useCustomMutation} from '../utils/useCustomMutation';
import {GenericErrorResponse} from "../typings";

// =============================================================================
// Mutation
// =============================================================================
interface Input {
  onSuccess?: (res: PaginatedData<AdminDetailsResponseContentObject>) => void;
  onError?: (error: AxiosError<GenericErrorResponse>) => void;
}

export const usePostAdminDetails = ({onError, onSuccess}: Input = {}) => {
  const postAdminDetails = async (reqBody: DataTableRequestSearchBody) => {
    const res = await axiosClient.post<PaginatedData<AdminDetailsResponseContentObject>>(
        POST_ADMIN_DETAILS_URL(reqBody.apiPathParam),
        {q: reqBody.q, selectedAdminUuids: reqBody.selectedAdminUuids}
    );

    return res.data;
  };

  return useCustomMutation(postAdminDetails, {
    onSuccess,
    onError,
  });
};
